export default {
    KW_GAP: 2,
    MANGOOLS_COMPETITORS: 1,
    GOOGLE: 0,
};
